import React from "react";
import {BasicPaperSession} from "../BasicPaperSession";
import Paper from "../Paper";
import {PaperSessionHeadPanel} from "../PaperSessionHeadPanel";


export class PaperSessionDetailModalBody extends BasicPaperSession {
    render() {
        const {paperSession} = this.props;
        const {papers, data} = paperSession;
        const keywordCounts = this.countKeywords(papers).slice(0, 4);

        return (
            <div className="panel panel-info session">
                <PaperSessionHeadPanel
                    data={data}
                    sessionColor={data.panel_color}
                    keywordCounts={keywordCounts}
                    paperCount={papers.length}
                    showPaperCount={true}
                    sessionNameClassName="sessionname-calendar"/>

                <div className="paperssession panel-body">
                    {papers.map((paper) =>
                        <Paper key={paper.id}
                               isInSession={true}
                               isInDetailModal={true}
                               removePaperFromSession={this.props.removePaperFromSession}
                               updatePapersFromSession={this.props.updatePapersFromSession}
                               paper={paper}/>
                    )}
                </div>
            </div>
        )
    }
}
